import { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: ['0.25rem', '0.5rem'], // mobile, desktop
  marginLeft: ['0.5rem', '2rem'], // mobile, desktop
  marginRight: ['0.5rem', '2rem'], // mobile, desktop
  marginTop: '0.5rem',
  marginBottom: '0.5rem',
  padding: ['0.5rem', '0.75rem'], // mobile, desktop
  bg: 'neutral/100', // Light background to distinguish from main items
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: 'neutral/200',
};

export const containerRowStyles: ThemeUIStyleObject = {
  alignItems: ['stretch', 'center'], // stack on mobile, center on desktop
  justifyContent: 'start',
  flexDirection: ['column', 'row'], // stack on mobile, horizontal on desktop
  gap: ['0.5rem', '1rem'], // mobile, desktop
  padding: ['0.5rem', '0.5rem 0.75rem'], // mobile, desktop
  borderBottom: '1px solid',
  borderColor: 'neutral/200',
  bg: 'neutral/000',
  borderRadius: '0.25rem',

  '&:last-child': {
    borderBottom: 'none',
  },

  // Desktop specific child sizing
  '@media (min-width: 768px)': {
    '& > *:nth-of-type(1)': {
      // Avatar + Name section
      flex: 1,
      minWidth: 0,
    },
    '& > *:nth-of-type(2)': {
      // Weight pill
      flexShrink: 0,
      minWidth: '4rem',
    },
    '& > *:nth-of-type(3)': {
      // Progress section
      flexShrink: 0,
      width: '12rem', // Slightly smaller than main items
    },
    '& > *:nth-of-type(4)': {
      // Status pill
      flexShrink: 0,
      minWidth: '5rem',
    },
  },
};

export const avatarSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: ['0.5rem', '0.75rem'], // mobile, desktop
  flex: [0, 1], // don't grow on mobile, grow on desktop
  width: ['100%', 'auto'], // full width on mobile
  minWidth: 0,
};

export const progressSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '0.25rem',
  width: ['100%', '12rem'], // full width on mobile, fixed on desktop
};

export const progressTextStyles: ThemeUIStyleObject = {
  textAlign: 'right',
  width: '2rem',
};
